<template>
  <div class="breadcrumbs">
    <span v-if="routes.length === 1">{{ t(`routes.${routes[0]}`) }}</span>
    <span v-else-if="routes.length === 2">
      <a @click="goBack">{{ t(`routes.${routes[0]}`) }}</a> >
      <span>{{ t(`routes.${routes[1]}`) }}</span>
    </span>
    <span v-else-if="routes.length > 2">
      <span>... > </span>
      <a @click="goBack">{{ t(`routes.${routes[routes.length - 2]}`) }}</a>
      >
      <span>{{ t(`routes.${routes[routes.length - 1]}`) }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import navigationService from '@/services/NavigationService';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const routes = ref<string[]>([]);

onMounted(() => {
  routes.value = navigationService.getHistory();
});

function goBack() {
  navigationService.goBack();
}
</script>

<style scoped lang="scss">
.breadcrumbs {
  padding-top: $space-1;
}

.breadcrumbs a {
  cursor: pointer;
  color: $color-text-dark;
  text-decoration: underline;
}
</style>
